import { registerForm } from "./IndicatorForm";

export default class Indicator {
  static getRegisterForm() {
    return registerForm;
  }
}
